import ModifierGroupsForm from 'components/ModifierGroups/Form'
import Layout from 'components/Layout'
import { useSelector } from 'react-redux'
import { isLoadingCategories } from 'store/Categories/selectors'
import { getIsItemsLoading } from 'store/Items/selector'
import Loader from 'components/Loader'

const ModifierGroupItemDetails = () => {
  const isCategoriesLoading = useSelector(isLoadingCategories)
  const isItemsLoading = useSelector(getIsItemsLoading)

  const isLoading = isCategoriesLoading || isItemsLoading
  return isLoading ? (
    <Loader />
  ) : (
    <Layout
      backTo="/modifier-groups"
      iconType="back"
      isSidebar
      mainContent={<ModifierGroupsForm />}
    />
  )
}

export default ModifierGroupItemDetails
